










































import SleepStoryResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/SleepStoryService/SleepStoryResponse";
import SleepStoriesFilterModel from "@/models/sleepStories/sleepStoriesFilterModel";
import { SLEEP_STORY_CREATE, SLEEP_STORY_EDIT } from "@/route-names";
import Vue from "vue";
import { Component, Inject } from "vue-property-decorator";
import EventBus from "@models/eventBus";
import SleepStoryCategoryCategoryResponse from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/SleepStoryService/SleepStoryCategoryCategoryResponse";
import TranslationModel from "@/api/dataSource/api/Spirit/Admin/Interfaces/Models/TranslationModel";

@Component
export default class PageSleepStoriesComponent extends Vue {
  @Inject("eventBus") eventBus: EventBus;
  filter: SleepStoriesFilterModel = new SleepStoriesFilterModel();
  columnNames = ["#", "Картинка", "Название", "Категории", "Платная", "Дата", "", ""];
  createSleepRouteName = SLEEP_STORY_CREATE;
  editSleepRouteName = SLEEP_STORY_EDIT;
  getDataFunc = this.$api.SleepStoryService.getSleepStoriesAsync.bind(
    this.$api.SleepStoryService
  );
  getMeditationName(meditation: SleepStoryResponse): string {
    return meditation.Translations.map((x) => `${x.LangCode}:${x.Name}`).join(
      "\n"
    );
  }

  getCategoryName(meditation: SleepStoryResponse): string {
    const translations = meditation.Categories.reduce(
      (a: TranslationModel[], b: SleepStoryCategoryCategoryResponse) => {
        return a.concat(b.Translations);
      },
      []
    );
    return translations.map((x) => `${x.LangCode}:${x.Name}`).join("\n");
  }

  removeFunc = this.$api.SleepStoryService.deleteSleepStoryAsync.bind(
    this.$api.SleepStoryService
  );
  async startDelete(item: SleepStoryResponse) {
    this.eventBus.deleteEntity.trigger({ id: item.Id });
  }
}
